import { render } from "./_PageSelectType.vue?vue&type=template&id=4bc6e99b&ts=true"
import script from "./_PageSelectType.vue?vue&type=script&lang=ts"
export * from "./_PageSelectType.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Hirofumi\\repository\\suite_totalling\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__